import type { PathSegment } from '@/types';

const isValidSegment = (segment: PathSegment) =>
  segment !== null && (typeof segment !== 'string' || segment.trim() !== '');

export default isValidSegment;
